// Content for the flat /site-cleanup-{suburb} SEO landing pages.
// These are distinct from /service-areas/:slug and follow a focused
// "single suburb landing" layout with LocalBusiness + FAQ schema.

export const SUBURB_LANDINGS = {
  craigieburn: {
    slug: "craigieburn",
    name: "Craigieburn",
    metaTitle: "Site Cleanup Craigieburn | Vacant Lot & Builder Waste Removal",
    metaDesc:
      "Professional site cleanup services in Craigieburn. Vacant lot cleanups, builder waste removal & pre-build site prep. Free quotes, fast response.",
    h1: "Site Cleanup Craigieburn",
    intro: [
      "Looking for reliable site cleanup in Craigieburn? Site Cleanup Melbourne is your trusted local partner for vacant lot cleanups, builder waste removal, and pre-build site preparation across Craigieburn and surrounding areas including Mickleham, Kalkallo, and Donnybrook.",
      "Craigieburn is one of Melbourne's fastest-growing northern corridors, with new residential developments and building projects launching every week. Whether you've just purchased a vacant block that's overgrown with weeds and debris, or you're a builder needing end-of-project waste removal, our matched local contractors deliver fast, professional results.",
      "Our services in Craigieburn include complete vacant lot cleanups to prepare land for construction, builder waste removal for active building sites, pre-build site preparation including levelling and debris clearing, and machinery coordination for larger jobs requiring bobcats or excavators.",
      "We connect you with one vetted local contractor who knows the Craigieburn area. There's no obligation, no cost for the quote, and you'll typically hear back within one business day. Whether it's a single residential block on Aitken Boulevard or a multi-lot development off Craigieburn Road, we've got you covered. Request your free quote today and get your Craigieburn site cleaned up fast.",
    ],
    faq: [
      {
        q: "Do you service all of Craigieburn?",
        a: "Yes, we cover all of Craigieburn including Mickleham, Kalkallo, and surrounding estates in the northern growth corridor.",
      },
      {
        q: "How much does a site cleanup in Craigieburn cost?",
        a: "Every site is different. Request a free no-obligation quote and our matched contractor will provide a tailored price based on your block size and conditions.",
      },
      {
        q: "Can you handle large development sites in Craigieburn?",
        a: "Absolutely. We coordinate machinery including bobcats and excavators for larger residential and commercial site cleanups.",
      },
    ],
  },
  epping: {
    slug: "epping",
    name: "Epping",
    metaTitle: "Site Cleanup Epping | Vacant Lot & Builder Waste Removal",
    metaDesc:
      "Professional site cleanup services in Epping, Melbourne. Vacant lot cleanups, builder waste removal & pre-build site prep. Free quotes, fast response.",
    h1: "Site Cleanup Epping",
    intro: [
      "Need a professional site cleanup in Epping? Site Cleanup Melbourne connects you with trusted local contractors for vacant lot cleanups, builder waste removal, and pre-build site preparation across Epping and nearby suburbs including Wollert, South Morang, and Lalor.",
      "Epping has experienced significant growth in recent years, with new housing estates and infill developments transforming the landscape. Whether you own a vacant block filled with construction debris, overgrown vegetation, or leftover materials from a previous build, getting it cleared quickly and affordably is essential before your project can begin.",
      "Our Epping site cleanup services include full vacant lot clearing and rubbish removal, builder waste collection during and after construction, pre-build site preparation so your land is ready for your builder, and machinery coordination for jobs that need heavy equipment like bobcats or mini excavators.",
      "We don't send your details to multiple contractors. Instead, we match you with one vetted professional who services the Epping area and can provide a competitive quote. The process is simple: submit your free quote request, receive a response within one business day, and get your site cleaned up without the hassle. From blocks near Epping Plaza to new estates off Harvest Home Road, we service it all. Get started with a free quote today.",
    ],
    faq: [
      {
        q: "Do you cover Epping North and South Morang?",
        a: "Yes, our service area includes all of Epping, Epping North, South Morang, Lalor, and surrounding suburbs.",
      },
      {
        q: "What's included in a vacant lot cleanup in Epping?",
        a: "Typically we remove overgrown vegetation, rubbish, construction debris, old fencing, and any dumped materials. The exact scope depends on your block.",
      },
      {
        q: "How fast can you clean my Epping site?",
        a: "Most residential lots are completed within 1-3 days of accepting the quote. Larger jobs may take longer depending on machinery requirements.",
      },
    ],
  },
  wollert: {
    slug: "wollert",
    name: "Wollert",
    metaTitle: "Site Cleanup Wollert | Vacant Lot & Builder Waste Removal",
    metaDesc:
      "Professional site cleanup services in Wollert, Melbourne. Vacant lot cleanups, builder waste removal & pre-build site prep. Free quotes, fast response.",
    h1: "Site Cleanup Wollert",
    intro: [
      "Searching for site cleanup services in Wollert? Site Cleanup Melbourne is your go-to partner for vacant lot cleanups, builder waste removal, and pre-build site preparation in Wollert and the surrounding growth areas including Epping North, Donnybrook, and Woodstock.",
      "Wollert is one of Melbourne's newest and fastest-developing suburbs, with major estates like Lyndarum North, Riverfield, and Upper Point Cook bringing thousands of new homes online. With so much construction activity, vacant blocks often accumulate weeds, dumped rubbish, builder waste, and debris that needs professional clearing before the next stage of development can proceed.",
      "Our site cleanup services in Wollert cover everything from small residential lot cleanups to larger multi-block clearing jobs. Services include complete vegetation and debris removal from vacant lots, builder waste cleanup during and after construction, pre-build site preparation to get your land builder-ready, and coordinated machinery hire for bigger jobs requiring earthmoving equipment.",
      "Your enquiry goes to one matched local contractor only, not a list of companies who will bombard you with calls. It's free to request a quote, there's zero obligation, and response times are typically within one business day. If you've got a block in Wollert that needs cleaning up, submit your details and let us handle the rest.",
    ],
    faq: [
      {
        q: "Do you service the new estates in Wollert?",
        a: "Yes, we service all Wollert estates including Lyndarum North, Riverfield, and the newer developments along Epping Road.",
      },
      {
        q: "My Wollert block has been illegally dumped on. Can you help?",
        a: "Yes, illegal dumping removal is a common request. Our contractor will assess the site and quote accordingly.",
      },
      {
        q: "Do I need to be present for the cleanup?",
        a: "Not usually. As long as site access is arranged, the contractor can complete the work without you being there.",
      },
    ],
  },
};

export const CORE_SERVICES = [
  {
    title: "Vacant Lot Cleanup",
    desc: "Full clearing of overgrown vegetation, rubbish and dumped materials from residential and commercial blocks.",
    icon: "Trees",
  },
  {
    title: "Builder Waste Removal",
    desc: "During- and post-construction waste collection — timber offcuts, packaging, concrete debris, plasterboard.",
    icon: "HardHat",
  },
  {
    title: "Pre-Build Site Preparation",
    desc: "Get your land builder-ready — levelling, debris clearing and prep so construction can start on schedule.",
    icon: "Ruler",
  },
  {
    title: "Machinery Coordination",
    desc: "Bobcat, mini-excavator and truck hire coordinated for larger clearing and earthmoving jobs.",
    icon: "Truck",
  },
];
